<template>
  <div class="row">
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Firm individuals</span></h5>
      <table v-if="firmIndividualsReceived" class="table table-striped">
        <thead>
        <tr>
          <th width="20%">
            Full name
          </th>
          <th width="20%">
            IRN
          </th>
          <th width="20%">
            Status
          </th>
          <th>
            Current roles & activities
          </th>
          <th>
            Disciplinary History
          </th>
          <th width="5%">

          </th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="(firmIndividual, index) in firmIndividuals" :key="index">
          <th>
              <input
                  type="text"
                  class="form-control"
                  name="firm_individual_name"
                  id="firm_individual_name"
                  placeholder="Full name"
                  v-model="firmIndividual.name"
                  :disabled="accountId !== 0"
              />
          </th>
          <th>
            <input
                type="text"
                class="form-control"
                name="firm_individual_irn"
                id="firm_individual_irn"
                placeholder="IRN"
                v-model="firmIndividual.irn"
                :disabled="accountId !== 0"
            />
          </th>
          <th>
            <input
                type="text"
                class="form-control"
                name="firm_individual_status"
                id="firm_individual_status"
                placeholder="status"
                v-model="firmIndividual.status"
                :disabled="accountId !== 0"
            />
          </th>
          <th>
            <v-select
                taggable
                multiple
                v-model="firmIndividuals[index].control_function"
                :options="controlFunctionOptions"
                push-tags
                @tag="addTag(index, $event)"
                :disabled="accountId"
            />
          </th>
          <th>
            <ul>
              <li v-for="item in firmIndividuals[index].disciplinary_history"><p>{{item.type_of_action}}</p></li>
            </ul>
          </th>
          <th>
            <button v-if="!accountId" type="button" class="btn btn-success" @click="saveItem(firmIndividuals[index])">
              <i class="fa fa-save" :id="'button_icon_' + firmIndividuals[index].id"></i>
            </button>
          </th>
        </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "FCAFormComponent",

  props: {
    csrfToken: {
      required: true,
      type: String,
    },
    accountId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      firmIndividuals: [
        {
          'name': null,
          irn: null,
          status: null,
          control_function: [],
        }
      ],
      firmIndividualsReceived: false,
      controlFunctionOptions: [],
    }
  },
  mounted() {
    this.getFcaData();
  },
  methods: {
    getFcaData() {
      const path = this.accountId ? `/member-firm/fca/${this.accountId}/get-data` : '/fca/get-data';
      axios.get(path).then((res) => {
        this.firmIndividuals = res.data.firm_individuals;
        this.controlFunctionOptions = [...new Set(res.data.control_functions)];
        this.firmIndividualsReceived = true;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    saveItem(item) {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
      axios.put(`/fca/update-individual-item/${item.id}`, item)
          .then((res) => {
            this.getFcaData();
          })
          .catch((error) => {
            console.log('error', error)
          })
    },
    addTag(index, newTag) {
      if (!this.firmIndividuals[index].control_function.includes(newTag)) {
        this.firmIndividuals[index].control_function.push(newTag);
      }
    },
  },
  created() {}
}
</script>

<style scoped>
:not(.input-group-btn) > .btn {
  padding: 2px 8px;
  border-radius: 0;
  margin: 0;
  background-color: #73C2AF;
}
</style>